module.exports = "/assets/images/love.png";